import './style.scss';

import {FC, ReactNode} from 'react';

import {matchPath, useLocation} from 'react-router-dom';
import classNames from 'classnames';

import AppHeader from 'layout/AppHeader';
import {useAuth} from 'hooks/useAuth';
import {VIEWER_TABS} from 'pages/NotificationViewer/Addons/definitions';

interface AppLayoutProps {
    children?: ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({children}) => {
    const location = useLocation();
    const {isAuthorized} = useAuth();

    // List pages fit the viewport: the page itself does not scroll, only
    // the table body does.
    const fitViewport = VIEWER_TABS.some(({route}) =>
        matchPath(location.pathname, {path: route.path, exact: true}),
    );

    return (
        <div className="app-layout">
            <header>
                {isAuthorized && <AppHeader/>}
            </header>
            <main
                className="app-layout__content"
                aria-label="App main">
                <div className={classNames('app-layout__wrapper', {'app-layout__wrapper--fit': fitViewport})}>
                    <div className="app-layout__container">
                        <div className="app-layout__body">
                            {children}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AppLayout;
